import { MdWarning } from 'react-icons/md';
import { Plover } from '@blisspointmedia/bpm-types/dist/webTrafficOptimization';
import { AlertDialog } from '@Components/AlertDialog';
import { Intent } from '@Components/designConstants';
import { useSetError } from '../../../redux/modals';
import { WtoLambdaFetch } from '../../../utils/fetch-utils';

interface ArchiveModalProps {
  show: boolean;
  closeModal: () => void;
  data: Plover;
  userEmail: string;
  fetchPlovers: () => void;
}

export const ArchiveModal = ({
  show,
  closeModal,
  data,
  userEmail,
  fetchPlovers
}: ArchiveModalProps) => {
  const setError = useSetError();

  const confirmArchive = async () => {
    try {
      await WtoLambdaFetch(`/plover/${data.id}`, {
        method: 'DELETE',
        params: {
          email: userEmail
        }
      });
      fetchPlovers();
    } catch (e) {
      setError({
        message: `Failed to archive plover. Error: ${e.message}`,
        reportError: e
      });
    }
  };

  return (
    <AlertDialog
      show={show}
      onHide={closeModal}
      intent={Intent.WARNING}
      icon={<MdWarning size={24} />}
      title='Archive Route'
      body={
        <>
          Are you sure you would like to archive this route: <span>{data.test_name}</span>?
          <br />
          <br />
          Archived Routes cannot be reactivated, new routes with similar parameters can be created.
          <br />
          <br />
          <i>
            IMPORTANT: This does not remove the Plover file from the website. Please contact your
            Engineering Lead assigned to your partner to remove file from the website.
          </i>
        </>
      }
      primaryAction={{ onClick: confirmArchive, label: 'Confirm' }}
      secondaryAction={{ onClick: closeModal }}
      passthroughProps={{ 'data-testid': 'archive-modal' }}
    />
  );
};
